export class EpEnvironmentService {
    public static get baseLocalUrl(): string { return window['ENVIRONMENT'].baseLocalUrl; } // @todo remove this
    public static get baseUrl(): string { return window['ENVIRONMENT'].baseUrl; }
    public static get paymentRedirectUrl(): string { return window['ENVIRONMENT'].paymentRedirectUrl; }
    public static get apiKey(): string { return window['ENVIRONMENT'].apiKey; }
    public static get subscriptionKey(): string { return window['ENVIRONMENT'].subscriptionKey; }
    public static get defaultTPAKey(): string { return window['ENVIRONMENT'].defaultTPAKey; }
    public static get instrumentationKey(): string { return window['ENVIRONMENT'].applicationInsights['instrumentationKey']; }
    public static get enforcePermissions(): boolean { return window['ENVIRONMENT'].enforcePermissions; }
    public static get enforcePermissionsSysAdmin(): boolean { return window['ENVIRONMENT'].enforcePermissionsSysAdmin; }
    public static get showInputTodayDate(): boolean { return (window['ENVIRONMENT'].baseUrl as string).includes('apisnonprd'); }
}
